/* eslint-disable react/jsx-props-no-spreading */
/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { DialogProps as MUIDialogProps } from '@material-ui/core';
import { Close } from '../Icons/generated';
import { StyledDialog } from './StyledDialog';
import { StyledIconButton } from './StyledIconButton';

interface DialogProps extends MUIDialogProps {
  testId: string;
}

const Dialog = (props: DialogProps) => {
  const { children, onClose, testId, ...rest } = props;
  const handleClose = () => {
    if (onClose) {
      onClose({}, 'escapeKeyDown');
    }
  };
  return (
    <StyledDialog onClose={onClose} data-cyid={`${testId}-dialog`} {...rest}>
      {onClose && (
        <StyledIconButton
          color="secondary"
          variant="text"
          aria-label="close"
          onClick={handleClose}
          size="tiny"
        >
          <Close />
        </StyledIconButton>
      )}
      {children}
    </StyledDialog>
  );
};

export default Dialog;
